<template>
  <div>
    <div class=" mainLoader" v-if="loading"></div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-side-bar :selectedItem="selectedItem"></app-side-bar>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('company_update')}}</span>
            </div>

            <div class="row pview">
              <form enctype="multipart/form-data" style="margin-top: 30px; display: contents;" @submit.prevent="doUpdateProfile" name="form" validate>
                <div class="col-md-3 text-center upload-btn-wrapper">
                  <progress-bar v-if="processUpload > 0 && !processUploadSuccess"
                    :options="options"
                    :value="processUpload"
                    />
                  <video v-if="company_video"  height="150" width="150" controls>
                      <source :src="company_video">
                  </video>

                  <img class="company" v-if="cropImg" :src="cropImg"  @click="editProfileImageButtonClick()"/>
                  <img class="avatar" style="width: 150px; height:150px;" v-if="!cropImg && !company_video" src="../../assets/imgs/default-user.png" @click="editProfileImageButtonClick()" />


                </div>
                <span class="camera imgbtn" @click="editProfileImageButtonClick()">
                     <i class="fa fa-camera" aria-hidden="true"></i>
                     <input type="file" name="myfile" ref="myfile" class="d-none" @change="readUrl($event)" />
                  </span>
                <div class="col-md-9">
                  <div class="form-group businesspanel input" :class="{ invalid: $v.name.$error && nameFocus }">
                    <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_name')}} <span style="color: red;">*</span></label>
                    <input
                        class="peditboxes peditinput linput form-control"
                        v-model="name"
                        :placeholder="$t('unify_test')"
                        autofocus/>
                        <div v-if="!$v.name.req && nameFocus" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>
                <div class="col-md-12" style="height: 10px;"></div>
                <div class="col-md-12 pheaderpanel">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack" style="margin-top: 17.5px; margin-bottom: 0px;">
                    {{$t('cp_basic_info')}}</p>
                  <div style="height: 20px;">
                    <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
                    <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
                  </div>
                </div>
                <div class="col-md-12" style="height: 11px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.address.$error && addressFocus }">
                  <label style="margin-top: 10px;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_location')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 input" :class="{ invalid: $v.address.$error && addressFocus }">
                  <input ref="autocomplete"
                      @keydown.enter.prevent
                      :placeholder="$t('unify_test')"
                      class="peditboxes peditinput linput form-control"
                      v-model="address"
                      id="locationName"
                      type="text" />
                      <div v-if="!$v.address.req && addressFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>
                <div class="col-md-12" style="height: 11px;"></div>
                <div class="col-md-3">
                  <label style="margin-top: 10px;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_edit_date')}}</label>
                </div>
                <div class="col-md-9">

                  <div v-if="sel_establishment_year != ''" class=" peselectboxs form-group">
                    <date-picker v-model="sel_establishment_year" :clearable='false' lang="en" type="year" style="min-width: 425px;" format="YYYY"></date-picker>

                  </div>
                </div>
                <div class="col-md-12"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.representative.$error && representativeFocus}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_representative')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 input form-group" :class="{ invalid: $v.representative.$error && representativeFocus }">
                  <input class="peditboxes peditinput linput form-control"
                          v-model="representative"
                          :placeholder="$t('unify_test')"
                          autofocus style="margin-top: 10px;" />
                  <div v-if="!$v.representative.req && representativeFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>
                <div class="col-md-12" style="height: 11px;"></div>
                <div class="col-md-3 input"  :class="{ invalid: $v.enterpriseURL.$error && enterpriseURLFocus}">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_e_url')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 form-group input"  :class="{ invalid: $v.enterpriseURL.$error && enterpriseURLFocus}">
                  <input
                        class="peditboxes peditinput linput form-control"
                        v-model="enterpriseURL"
                        :placeholder="$t('unify_test')"
                        autofocus style="margin-top: 10px;" />
                        <div v-if="!$v.enterpriseURL.req && enterpriseURLFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>

                <div class="col-md-12" style="height: 21px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.numOfEmployees.$error }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_noe')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 input form-group" :class="{ invalid: $v.numOfEmployees.$error }">
                  <input class="peditboxes peditinput linput form-control"
                         v-model="numOfEmployees"
                         :placeholder="$t('unify_test')"
                         autofocus
                         style="margin-top: 10px;" />
                    <div v-if="!$v.numOfEmployees.req && numOfEmployeesFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>
                <div class="col-md-12" style="height: 21px;"></div>

                <div class="col-md-12 input form-group" :class="{ invalid: $v.companyDescription.$error }">
                  <div class="pfpanel">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('cp_company_desc')}} <span style="color: red;">*</span></label>
                    <span style="float: right; margin-top: 22px;" class="futhergraytxt mplus2p-m spacing1-2 noiseblack"></span>
                  </div>
                  <textarea rows="7"
                            class="peditboxes pedittextarea form-control"
                            v-model="companyDescription"
                            autofocus
                            :placeholder="$t('unify_test')">

                  </textarea>
                  <div v-if="!$v.companyDescription.req && companyDescriptionFocus" class="help-block">{{$t('required_filed')}}</div>
                </div>
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.sel_recruitment_situation.$error }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('recruitment_situation')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 input form-group" :class="{ invalid: $v.sel_recruitment_situation.$error }">
                  <div class="selectdiv peselectboxs " style="min-width: 425px;">
                    <select class="form-control"
                            name="recruitment"
                            v-model="sel_recruitment_situation.id"
                            autofocus>
                      <option v-if="sel_recruitment_situation == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of recruitment_situations" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_recruitment_situation.id" :value="i.id">{{lan == 'en' ? i.en_situation : i.jp_situation}}
                      </option>
                    </select>
                    <div v-if="!$v.sel_recruitment_situation.req && situationfocus" style="margin-left:0px" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('benefit')}}</label>
                </div>
                <div class="col-md-9">
                  <div class="form-group" style="width: 425px ;">
                    <ul  class="list-unstyled mb-0 peselectboxs form-control custom-wrapper" id="wantedjob">
                      <li v-for="(benefit,index) of benefits" :key="index">
                        <label :for="benefit.id" class="custom-control material-checkbox">
                          <input type="checkbox" class="material-control-input" v-model="check_benefit[index]"
                                 :id="benefit.id" :value="benefit.id">
                          <span class="material-control-indicator"></span>
                          <span class="material-control-description">{{lan == 'en' ? benefit.en_benefit : benefit.jp_benefit}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="col-md-3 input" :class="{ invalid: $v.sel_ratio_of_engineer.$error }">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ratio_of_engineer')}} <span style="color: red;">*</span></label>
                </div>
                <div class="col-md-9 input" :class="{ invalid: $v.sel_ratio_of_engineer.$error }">
                  <div v-if="sel_ratio_of_engineer != ''" class="selectdiv peselectboxs form-group" style="min-width: 425px;">
                    <select class="form-control"
                            name="listed"
                            v-model="sel_ratio_of_engineer.id"
                            autofocus>
                      <option v-if="sel_ratio_of_engineer == ''" class="mplus2p-r black" style="font-size: 0.875rem;" value="">{{$t('r_select')}}</option>
                      <option v-for="(i,index) of retio_of_engineer" :key="index" class="mplus2p-r black" style="font-size: 0.875rem;" :selected="sel_ratio_of_engineer.id" :value="i.id">{{lan == 'en' ? i.en_ratio : i.jp_ratio}}
                      </option>
                    </select>
                    <div v-if="!$v.sel_ratio_of_engineer.req && engineerFocus" style="margin-left:0px" class="help-block">{{$t('required_filed')}}</div>
                  </div>
                </div>
                <div class="col-md-12" style="height: 80px;"></div>
                <div class="col-md-12 pv_btnpanel">
                  <button type="submit"  class="btn bluebtn updatebtn">{{$t('cp_edit_update')}}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade companyProfileImage" id="companyProfileImage" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button>
          </div>
          <div class="modal-body m-cropper-hide" style="text-align: center;">
            <div style="width: 315px; height: 300px ; display: inline-block;">
              <vue-cropper ref='cropper'
                      :guides="true"
                      :view-mode="0"
                      drag-mode="crop"
                      :auto-crop-area="1"
                      :minCanvasWidth="300"
                      :minCanvasHeight="300"
                      :minCropBoxWidth="300"
                      :minCropBoxHeight="300"
                      :min-container-width="300"
                      :min-container-height="300"
                      :background="false"
                      :zoomable="false"
                      :zoomOnTouch="false"
                      :zoomOnWheel="false"
                      :aspectRatio= "1"
                      :cropBoxResizable="false"
                      :rotatable="true" :src="imgSrc" alt="Source Image" :img-style="{ 'width': '400px', 'height': '300px' }">
              </vue-cropper>
            </div>
             <img style="object-fit: contain; object-position: left center; width:152px; height: 152px; border-radius: 10px" alt="Cropped Image" v-if="cropImg" :src="cropImg" />
            <img style="object-fit: contain; object-position: left center; width:152px; height: 152px; border-radius: 10px" alt="Cropped Image" v-if="!cropImg" src="../../assets/imgs/companydummy.png" />
            <br/>
            <br/>
            <button @click="cropImage">{{$t('cp_image_crop')}}</button>
            <!-- <button @click="rotate">{{$t('cp_image_rotate')}}</button> -->
          </div>
          <div class="modal-footer">
            <button class='btn bluebtn DoneCrop' @click="uplodImage" data-dismiss="modal">{{$t('cp_done')}}</button>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="d-none" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#companyProfileImage" ref="myBtnCompanyEdit">
      Launch demo modal
    </button>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import * as $ from "jquery";
import DatePicker from "vue2-datepicker";
import VueCropper from "vue-cropperjs";
import NavSidebar from "./company_sidebar";
import axios from "axios";
import { EventBus } from "../../main.js";

export default {
  mixins: [validationMixin],

  validations: {
    name: { req: required },
    representative: { req: required },
    numOfEmployees: { req: required },
    enterpriseURL: { req: required },
    address: { req: required },
    companyDescription: { req: required },
    sel_recruitment_situation: { req: required },
    sel_ratio_of_engineer: { req: required }
  },
  data() {
    return {
      nameFocus: false,
      representativeFocus: false,
      numOfEmployeesFocus: false,
      companyDescriptionFocus: false,
      addressFocus: false,
      enterpriseURLFocus: false,
      situationfocus: false,
      businessFocus: false,
      listedFocus: false,
      engineerFocus: false,
      selectedItem: 71,
      loading: false,

      company_video: '',

      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#3d7dd8',
          backgroundColor: '#C0C0C0'
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      },
      processUpload: 0,
      processUploadSuccess: false,


      userId: "",
      companyId: "",

      cropImg: "",
      imgSrc: "",
      img: [],
      imageBlob: "",

      location: "",
      location_types: {
        administrative_area_level_1: "",
        administrative_area_level_2: "",
        locality: "",
        sublocality_level_1: "",
        sublocality_level_2: "",
        sublocality_level_3: "",
        sublocality_level_4: "",
        premise: ""
      },
      latitude: "",
      longitude: "",

      name: "",
      address: "",
      autocomplete: "",

      sel_establishment_year: "",
      establishment_years: [],

      representative: "",
      enterpriseURL: "",
      numOfEmployees: "",

      companyDescription: "",
      idea: "",
      vision: "",

      sel_recruitment_situation: "",
      recruitment_situations: [],

      check_benefit: [],
      sel_benefit: "",
      benefits: [],

      sel_ratio_of_engineer: "",
      retio_of_engineer: [],

      sel_recruitment_tension: "",
      recruitment_tension: [],

      sel_schedule: "",
      schedule: [],

      sel_type_of_contract: "",
      type_of_contract: [],

      sel_company_hire_engineer: "",
      company_hire_engineer: [],

      lan: "jp"
    };
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
    var componentForm = {
      administrative_area_level_1: "administrative_area_level_1",
      administrative_area_level_2: "administrative_area_level_2",
      locality: "locality",
      sublocality_level_1: "sublocality_level_1",
      sublocality_level_2: "sublocality_level_2",
      sublocality_level_3: "sublocality_level_3",
      sublocality_level_4: "sublocality_level_4",
      premise: "premise"
    };
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ["geocode"] }
    );
    this.autocomplete.addListener("place_changed", () => {
      let place = this.autocomplete.getPlace();
      let val = [];
      let place_address = place.address_components.reverse();
      for (var i = 0; i < place_address.length; i++) {
        var addressType = place_address[i].types[0];
        if (componentForm[addressType] != undefined) {
          if (componentForm[addressType] == "administrative_area_level_1") {
            val.push(place.address_components[i].long_name);
            this.location_types.administrative_area_level_1 =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "administrative_area_level_2") {
            val.push(place.address_components[i].long_name);
            this.location_types.administrative_area_level_2 =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "locality") {
            val.push(place.address_components[i].long_name);
            this.location_types.locality =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "sublocality_level_1") {
            val.push(place.address_components[i].long_name);
            this.location_types.sublocality_level_1 =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "sublocality_level_2") {
            val.push(place.address_components[i].long_name);
            this.location_types.sublocality_level_2 =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "sublocality_level_3") {
            val.push(place.address_components[i].long_name);
            this.location_types.sublocality_level_3 =
              place.address_components[i].long_name;
          }
          if (componentForm[addressType] === "sublocality_level_4") {
            val.push(place.address_components[i].long_name );
            this.location_types.sublocality_level_4 =
              place.address_components[i].long_name ;
          }
          if (componentForm[addressType] === "premise") {
            var keys = Object.keys(place.address_components[i].long_name)
            if (keys.length == 1) {
              val.push('-')
              this.location_types.premise += '-'
            }
            val.push(place.address_components[i].long_name);
            this.location_types.premise = place.address_components[i].long_name;
          }
        }
      }
      $("#locationName").val(val.join(''));
      if (place.address_components) {
        let ac = place.address_components;
        let lat = place.geometry.location.lat();
        let lon = place.geometry.location.lng();
        let city = ac[0]["long_name"];
        this.location = $("#locationName").val();
        this.latitude = lat;
        this.longitude = lon;
      } else {
        return;
      }
    });
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if (localStorage.getItem("role") == "engineer") {
      return this.$router.push("/global/PageNotFound");
    }
    var data = JSON.parse(localStorage.getItem("user"));
    var uId = data.user_token;
    var cId = data.company.company_token;
    if (uId != this.$route.params.uid || cId != this.$route.params.cid) {
      this.$router.push("/global/PageNotFound");
    }

    this.userId = data.id;
    this.companyId = data.company.id;
    this.getCompanyProfile(this.companyId);
  },
  components: {
    appSideBar: NavSidebar,
    DatePicker
  },
  methods: {
    editProfileImageButtonClick() {
      this.$refs["myfile"].click();
    },
    isSelectedBenefit() {
      for (var i = 0; i <= this.benefits.length - 1; i++) {
        var isSelected = this.sel_benefit.findIndex(obj => {
          return obj.id == this.benefits[i].id;
        });
        this.check_benefit[i] = isSelected != -1 ? true : false;
      }
      this.$forceUpdate();
    },
    getEstablishment() {
      axios
        .get("/establishment-years")
        .then(res => {
          this.establishment_years = res.data.years;
        })
        .catch(error => console.log(error));
    },
    getRecruitmentSituation() {
      axios
        .get("/recruitment-situation")
        .then(res => {
          this.recruitment_situations = res.data.situations;
        })
        .catch(error => console.log(error));
    },
    getBenefits() {
      axios
        .get("/benefits")
        .then(res => {
          this.benefits = res.data.benefits;
          this.isSelectedBenefit();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getRetioOfEngineer() {
      axios
        .get("/ratio-of-engineer")
        .then(res => {
          this.retio_of_engineer = res.data.ratios;
        })
        .catch(error => console.log(error));
    },
    getRecruitmentTension() {
      axios
        .get("/recruitment-tension")
        .then(res => {
          this.recruitment_tension = res.data.tensions;
        })
        .catch(error => console.log(error));
    },
    getSchedule() {
      axios
        .get("/freelance-types")
        .then(res => {
          this.schedule = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getTypeOfContract() {
      axios
        .get("/contract-types")
        .then(res => {
          this.type_of_contract = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getCompanyHireEngineer() {
      axios
        .get("/why-hire-engineers")
        .then(res => {
          this.company_hire_engineer = res.data.reasons;
        })
        .catch(error => console.log(error));
    },
    clickedSex(flag) {
      this.model.sex = flag;
      if (flag === 0) {
        $(".womenradio").removeClass("wchosen");
        $(".manradio").addClass("mchosen");
      }
      if (flag === 1) {
        $(".manradio").removeClass("mchosen");
        $(".womenradio").addClass("wchosen");
      }
    },
    readUrl(e) {
      const file = e.target.files[0];
      // this.img.push(e.target.files[0].name);
      if (file.type === 'image/gif' || file.type === 'video/mp4') {
        this.processUploadSuccess = false;
        if (file.type === 'video/mp4') {
          if (file.size > 5242880) {
						this.$toaster.error('File size must not be more than 5 MB');
						return;
					}
          var reader = new FileReader();
          reader.onload = event => {
            this.cropImg = ''
            this.company_video = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }else{
          var reader = new FileReader();
          reader.onload = event => {
            this.company_video = ''
            this.cropImg = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }
        this.imageBlob = file
        e.target.value = '';
        return;
      }

       if (!file.type.includes("image/") || !file.type === 'image/gif' || !file.type === 'video/mp4') {
        this.$toaster.error('Please select an image or GIF or MP4 file');
        return;
      }

      if (typeof FileReader === "function") {
        var reader = new FileReader();
        reader.onload = event => {
          //vm.image = event.target.result;
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          this.showModal();
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      e.target.value = "";
    },
    showModal() {
      const elem = this.$refs.myBtnCompanyEdit;
      elem.click();
    },
    cropImage() {
      this.cropLoader = true;
      setTimeout(() => {
        this.company_video = ''
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.cropLoader = false;
      }, 500);

      var data = this.$refs.cropper.getCroppedCanvas({
        width: 160,
        height: 90,
        minWidth: 256,
        minHeight: 256,
        maxWidth: 4096,
        maxHeight: 4096,
        fillColor: "#fff",
        imageSmoothingEnabled: false,
        imageSmoothingQuality: "high"
      });
      fetch(data.toDataURL())
        .then(obj => {
          return obj.blob();
        })
        .then(blob => {
          this.imageBlob = blob;
        });
    },
    rotate() {
      this.$refs.cropper.rotate(90);
    },
    uplodImage(){
        var formData = new FormData();
        if (this.imageBlob.type === "image/png" || this.imageBlob.type === 'image/gif' || this.imageBlob.type === 'image/jpg' || this.imageBlob.type === 'image/jpeg') {
          formData.append("image", this.imageBlob, 'temp.png');
        }else{
            formData.append("video", this.imageBlob, this.imageBlob.name);
        }
        const vm = this
        var config = {
            onUploadProgress: function(progressEvent) {
              vm.processUpload = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            }
          };
        axios
          .post(
            "/company-image-upload/"+this.companyId +"?token=" + localStorage.getItem("token"),
            formData,
            config,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            },

          )
          .then(res => {
            let thisVue = this;
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
              this.loading = false;
            } else {
              this.processUploadSuccess = true;
              var user = JSON.parse(localStorage.getItem("user"))
              user.image = res.data.file;
              localStorage.setItem("user", JSON.stringify(user));
              this.$toaster.success(thisVue.$t('success_file_upload'));
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    getCompanyProfile(id) {
      this.loading = true;
      axios
        .get("/company/" + id + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            try {
              this.name = res.data.company.name;
              if (res.data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                this.company_video = res.data.company.image
              }else{
                this.cropImg = res.data.company.image;
              }
              this.address = res.data.company.location;
              this.location = res.data.company.location;

              if (res.data.company.location_types) {
                let location_data = JSON.parse(res.data.company.location_types)
                this.location_types = {
                    administrative_area_level_1: location_data.administrative_area_level_1,
                    administrative_area_level_2: location_data.administrative_area_level_2,
                    locality: location_data.locality,
                    sublocality_level_1: location_data.sublocality_level_1,
                    sublocality_level_2: location_data.sublocality_level_2,
                    sublocality_level_3: location_data.sublocality_level_3,
                    sublocality_level_4: location_data.sublocality_level_4,
                    premise: location_data.premise
                }
              }
              this.sel_establishment_year = res.data.company.establishment_year
                ? new Date(
                    res.data.company.establishment_year,
                    11,
                    11,
                    0,
                    0,
                    0,
                    0
                  )
                : new Date().getFullYear();
              this.representative = res.data.company.representative;
              this.enterpriseURL = res.data.company.enterprise_url;
              this.numOfEmployees = res.data.company.number_of_employees;
              this.companyDescription = res.data.company.company_description;
              this.latitude = res.data.company.latitude;
              this.longitude = res.data.company.longitude;
              this.sel_recruitment_situation = res.data.company
                .recruitment_situation
                ? res.data.company.recruitment_situation
                : { id: "" };
              this.sel_benefit = res.data.company.benefits
                ? res.data.company.benefits
                : { id: "" };
              this.sel_ratio_of_engineer = res.data.company.ratio_of_engineer
                ? res.data.company.ratio_of_engineer
                : { id: "" };
              this.loading = false;
              this.getEstablishment();
              this.getRecruitmentSituation();
              this.getRetioOfEngineer();
              this.getRecruitmentTension();
              this.getSchedule();
              this.getTypeOfContract();
              this.getCompanyHireEngineer();
              this.getBenefits();
            } catch (error) {}
          }
        })
        .catch(error => console.log(error));
    },
    doUpdateProfile() {
      var cid = this.$route.params.cid;
      var uid = this.$route.params.uid;
      this.loading = true;
      const thisVue = this;
      var formData = new FormData();
      formData.append("name", this.name);
      formData.append("representative", this.representative);
      formData.append("enterprise_url", this.enterpriseURL);
      formData.append("number_of_employees", this.numOfEmployees);
      formData.append(
        "company_description",
        this.companyDescription ? this.companyDescription : ""
      );
      formData.append("idea", this.idea);
      formData.append("vision", this.vision);
      formData.append(
        "establishment_year_id",
        new Date(this.sel_establishment_year).getFullYear()
      );
      formData.append(
        "recruitment_situation_id",
        this.sel_recruitment_situation.id
      );
      formData.append(
        "ratio",
        this.sel_ratio_of_engineer.id ? this.sel_ratio_of_engineer.id : ""
      );
      formData.append(
        "recruitment_tension_id",
        this.sel_recruitment_tension.id ? this.sel_recruitment_tension.id : ""
      );
      formData.append(
        "freelance_type_id",
        this.sel_schedule.id ? this.sel_schedule.id : ""
      );
      formData.append(
        "contract_type_id",
        this.sel_type_of_contract.id ? this.sel_type_of_contract.id : ""
      );
      formData.append(
        "hire",
        this.sel_company_hire_engineer.id
          ? this.sel_company_hire_engineer.id
          : ""
      );
      formData.append("location_types", JSON.stringify(this.location_types));
      if (this.imageBlob != "") {
        formData.append("image", this.imageBlob, "temp.png");
      }
      var arr = [];
      for (var i = 0; i <= this.check_benefit.length - 1; i++) {
        if (this.check_benefit[i]) {
          arr.push(this.benefits[i].id);
        }
      }
      for (var i = 0; i < arr.length; i++) {
        formData.append("benefits[" + i + "]", arr[i]);
      }
      if (this.address == "") {
        formData.append("location", this.location);
        formData.append("longitude", "" + this.longitude + "");
        formData.append("latitude", "" + this.latitude + "");
      } else {
        formData.append("location", this.location);
        formData.append("longitude", "" + this.longitude + "");
        formData.append("latitude", "" + this.latitude + "");
      }

      formData.append("location_types", JSON.stringify(this.location_types));


      this.$v.$touch();
      if (this.$v.$invalid) {
        this.nameFocus = true;
        this.representativeFocus = true;
        this.numOfEmployeesFocus = true;
        this.companyDescriptionFocus = true;
        this.addressFocus = true;
        this.enterpriseURLFocus = true;
        this.situationfocus = true;
        this.businessFocus = true;
        this.listedFocus = true;
        this.engineerFocus = true;
        this.loading = false;
        setTimeout(() => {
          $("html, body").animate(
            { scrollTop: $($(".invalid")[0]).position().top + 300 },
            "slow"
          );
        }, 1);
      } else {
        axios
          .post(
            "/company/edit/" +
              this.companyId +
              "?token=" +
              localStorage.getItem("token"),
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
              headers: { "X-localization": localStorage.getItem("lan") }
            }
          )
          .then(res => {
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  if (res.data.errors[i].field === "name") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "location") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "longitude") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "latitude") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "establishment_year_id") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "representative") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "person_in_charge") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "enterprise_url") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "company_description") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "service_description") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "idea") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "vision") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "number_of_employees") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "business_type") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "company_type") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "ratio") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "recruitment_tension_id") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "freelance_type_id") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "contract_type_id") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                  if (res.data.errors[i].field === "hire") {
                    this.$toaster.error(res.data.errors[i].message);
                  }
                }
              }
              this.loading  = false;
            } else {
              this.loading = false;
              this.$router.push("/company/profile/" + cid + "/" + uid);
              this.$toaster.success(thisVue.$t("success_edit_profile"));

            }
          })
          .catch(() => {
            this.$toaster.error(thisVue.$t("err_network"));
          });
      }
    }
  }
};
</script>

<style scoped>
.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.input.invalid select {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.input.invalid textarea {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.input {
  padding-right: 0px;
}
.custom-control.material-checkbox {
  --color: #3d7dd8;
}

.custom-control.material-checkbox .material-control-input {
  display: none;
}

.custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
  border-color: var(--color);
  -webkit-transform: rotateZ(45deg) translate(1px, -5px);
  transform: rotateZ(45deg) translate(1px, -5px);
  width: 10px;
  border-top: 0px solid #fff;
  border-left: 0px solid #fff;
}

.custom-control.material-checkbox .material-control-indicator {
  display: inline-block;
  position: absolute;
  top: 4px;
  left: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #aaa;
  transition: 0.3s;
}

.pman {
  width: auto;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.company {
  width: 147px;
  height: 147px;
  object-fit: contain;
  object-position: center;
  border-radius: 10px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.camera {
  box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
  background-color: #ffffff;
  border: solid 1px #c8d2dc;
  border-radius: 100px;
  padding: 8px 9px;

  position: absolute;
  /* top: 105px;
  right: 32px; */
  top: 242px;
  left: 80px;
  cursor: pointer;
}

.camera:hover {
  background-color: #3d7dd8;
}

.camera:hover .fa-camera {
  color: white;
}

.camera .fa-camera {
  font-size: 20px;
  color: #3d7dd8;
}

.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 20px;
}

.peditinput {
  width: 100%;
  height: 44px;
  padding: 0px 16px;
  margin-left: 20px;
}

.pedittextarea {
  width: 100%;
  padding: 16px;
  margin-left: 20px;
}

.peselectboxs {
  float: left;
  margin-left: 20px;
}

.selectdiv select {
  height: 50px !important;
}

.peradioboxs {
  text-align: center;
  min-width: 128px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 20px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}

.peradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}

.linput {
  width: 423px;
}

.help-block {
  margin-left: 20px;
  margin-top: 10px;
}

.form-group {
  margin-bottom: 0px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  top: 105px;
  right: 30px;
  opacity: 0;
}

.pheaderpanel {
  margin: 0px 20px;
  margin-top: 30px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.businesspanel {
  margin-top: -20px;
}

.futhergraytxt {
  font-size: 1rem;
  font-weight: 500;
  opacity: 0.64;
}

.pfpanel {
  height: 50px;
}

@media screen and (max-width: 1200px) {
  .camera {
    top: 80px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80px;
    right: 20px;
  }

  .businesspanel {
    margin-top: 20px;
  }
}

@media screen and (max-width: 992px) {
  .camera {
    top: 50px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 50px;
    right: 20px;
  }

  .linput {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .company {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .camera {
    top: 80%;
    right: 27%;
  }

  .peditlabel {
    margin-left: 0px;
  }

  .peditinput {
    margin-left: 0px;
  }

  .pedittextarea {
    margin-left: 0px;
  }

  .peselectboxs {
    width: 100%;
    margin-left: 0px;
  }

  .peradioboxs {
    width: 100%;
    margin-left: 0px;
  }

  .help-block {
    margin-left: 0px;
    margin-top: 10px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80%;
    right: 20%;
  }

  .pheaderpanel {
    margin: 0px;
    margin-top: 30px;
  }
}

@media screen and (max-width: 575.98px) {
  .pman {
    width: 100%;
  }
}
</style>
